<div class="main-group">
	<!--			-->
	<!-- Item Count -->
	<!--			-->
	<div class="main-group-item">
		<div class="main-group-item-center">
			<label class="label-item-total">{{ ItemsChangedMessage }}</label>
		</div>
	</div>

	<!-- 					   -->
	<!-- Student Card Selector -->
	<!-- 				  	   -->
	<div class="main-group-item" [style.display]="StudentCount == 0 ? 'none' : 'block'">
		<div class="selector-item">
			<div class="selector-label-div">
				<label class="label-item">Student Card</label>
			</div>

			<div style="margin-left: 10px; width: 300px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="StudentCardSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedStudentCard"
					(ngModelChange)="onStudentCardChange($event)"
				>
					<option *ngFor="let r of lstStudentCard" [ngValue]="r">
						{{ r.CardName }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!-- 					   -->
	<!-- Staff Card Selector -->
	<!-- 				  	   -->
	<div class="main-group-item" [style.display]="StaffCount == 0 ? 'none' : 'block'">
		<div class="selector-item">
			<div class="selector-label-div">
				<label class="label-item">Staff Card</label>
			</div>

			<div style="margin-left: 10px; width: 300px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<select
					class="form-control"
					name="StaffCardSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedStaffCard"
					(ngModelChange)="onStaffCardChange($event)"
				>
					<option *ngFor="let r of lstStaffCard" [ngValue]="r">
						{{ r.CardName }}
					</option>
				</select>
			</div>
		</div>
	</div>

	<!--	   -->
	<!-- Notes -->
	<!--	   -->
	<div class="main-group-item">
		<div>
			<label class="label-item">Note:</label>
			<label style="margin-left: 10px"
				>Any print queue records that were selected that did not have the status of [Review Pending] have been prefiltered.</label
			>
		</div>
	</div>

	<!--				-->
	<!-- Error Message  -->
	<!--				-->
	<div class="main-group-item" [style.display]="ErrorMessage != '' ? 'block' : 'none'">
		<div>
			<label class="error-message">{{ ErrorMessage }}</label>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" [disabled]="isBusy == true" (click)="onSetCard()">Ok</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
